<template lang="pug">
    div.alert-rules-container
        div.d-flex.justify-space-between.align-center.mb-4.pa-4
            v-btn(
                color="primary"
                @click="startCreate"
                elevation="2"
                class="create-button"
                small
            )
                v-icon(left) mdi-plus
                | Create Alert Rule
            HelpMenu(
                :help-definitions='helpDefinitions'
                :title='`Alert Rule Defaults`'
            )
        div.table-container
            TableFixedHeader(
                dark=true
                :hide-count='true'
                :items="rules"
                :is-loading="isLoading"
                :height="300"
                v-show="validRules || isLoading"
            )
                template(v-slot:th-default)
                    th.text-center.white--text Rule Action
                    th.text-center.white--text Color
                    th.text-center.white--text Metric Threshold
                    th.text-center
                    th.text-center
                template(v-slot:tr-default="slotProps")
                    td.text-center {{ getRuleActionText(slotProps.item.rule_action) }}
                    td.text-center
                        v-avatar(
                            :color="slotProps.item.display_color"
                            size="12"
                        )
                    td.text-center {{ slotProps.item.metric + ` (${slotProps.item.metric_unit})` }}
                    td.text-center
                        v-btn(small color="warning" @click="editRule(slotProps.item)")
                            v-icon mdi-pencil
                    td.text-center
                        v-btn(small color="error" @click="deleteRule(slotProps.item)")
                            v-icon mdi-trash-can-outline

        v-alert(v-if="!validRules && !isLoading" outlined type='info' dense border='left' style="margin-top: 0px;")
            | No alert rules found. Please create one. 
</template>

<script lang="ts">
import Vue from 'vue';

// Components
import TableFixedHeader from '@/components/shared/table_fixed_header.vue';
import HelpMenu from "@/components/reports/help_menu.vue";


export default Vue.extend({
    data() {
        return {
            ruleActions: [
                {
                    value: 'ib_calls_warning',
                    text: 'Avg. Inbound Calls Warning'
                },
                {
                    value: 'ob_calls_warning',
                    text: 'Avg. Outbound Calls Warning'
                },
                {
                    value: 'ob_calls_critical',
                    text: 'Avg. Outbound Calls Critical'
                },
                {
                    value: 'ib_calls_critical',
                    text: 'Avg.Inbound Calls Critical'
                },
                {
                    value: 'avg_hold_duration_warning',
                    text: 'Avg. Hold Duration Warning'
                },
                {
                    value: 'avg_hold_duration_critical',
                    text: 'Avg. Hold Duration Critical'
                },
                {
                    value: 'agent_status_warning_account',
                    text: 'Agent Status Warning'
                },
                {
                    value: 'agent_status_critical_account',
                    text: 'Agent Status Critical'
                }
            ]
        }
    },
    methods: {
        
        deleteRule(rule) {
            this.$emit('destroy', rule)
        },
        editRule(rule) {
            this.$emit('edit', rule)
        },
        getRuleActionText(ruleAction) {
            return this.ruleActions.find(action => action.value === ruleAction)?.text || ruleAction
        },
        startCreate() {
            this.$emit('create')
        },
    
    },  
    computed: {
        validRules() {
            return this.rules?.length > 0
        },
        helpDefinitions() {
            return [
                {
                    title: 'Call Volume Defaults',
                    description: `
                        <div style="display: flex; align-items: center; gap: 32px; margin: 4px 0">
                            <span style="min-width: 120px">IB/OB Calls:</span>
                            <div style="display: flex; align-items: center;">
                                2 min <span style="display: inline-block; width: 10px; height: 10px; background-color: var(--orange); margin: 0 4px"></span>
                                (Warn)
                            </div>
                            <div style="display: flex; align-items: center;">
                                3 min <span style="display: inline-block; width: 10px; height: 10px; background-color: var(--error); margin: 0 4px"></span>
                                (Flash)
                            </div>
                        </div>
                    `
                },
                {
                    title: 'Hold Duration Defaults',
                    description: `
                        <div style="display: flex; align-items: center; gap: 32px; margin: 4px 0">
                            <span style="min-width: 120px">Average Hold Time:</span>
                            <div style="display: flex; align-items: center;">
                                30 sec <span style="display: inline-block; width: 10px; height: 10px; background-color: var(--orange); margin: 0 4px"></span>
                                (Warn)
                            </div>
                            <div style="display: flex; align-items: center;">
                                45 sec <span style="display: inline-block; width: 10px; height: 10px; background-color: var(--error); margin: 0 4px"></span>
                                (Flash)
                            </div>
                        </div>
                    `
                },
                {
                    title: 'Agent Status Defaults',
                    description: `
                        <div style="display: flex; align-items: center; gap: 32px; margin: 4px 0">
                            <span style="min-width: 120px">Time in Status:</span>
                            <div style="display: flex; align-items: center;">
                                2 min <span style="display: inline-block; width: 10px; height: 10px; background-color: var(--orange); margin: 0 4px"></span>
                                (Warn)
                            </div>
                            <div style="display: flex; align-items: center;">
                                3 min <span style="display: inline-block; width: 10px; height: 10px; background-color: var(--error); margin: 0 4px"></span>
                                (Flash)
                            </div>
                        </div>
                    `
                },
                {
                    title: '',
                    description: `
                        <div style="font-size: 12px; color: var(--volie-gray); margin-top: 4px; font-style: italic">
                            *When a value exceeds the threshold, its cell will be highlighted with the color for that rule. Critical thresholds trigger a flashing effect.
                        </div>
                    `
                }
            ];
        },

    },
    components: {
        TableFixedHeader,
        HelpMenu, 
    },
    props: {
        rules: Array,  
        isLoading: Boolean,
    },
    watch: {

    },
    created() {
    },
    destroyed() {
    },
    mounted() {
    },
})
</script>

<style lang="scss" scoped>
.alert-rules-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.table-container {
    flex: 1;
    overflow: auto;
    max-height: 300px;
    min-height: 180px;
}

.create-button {
    min-width: 150px;
    z-index: 1;
}
</style>